var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GateTrainDailyCalendar',{attrs:{"showFilters":"","filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }